import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { UtilisateurReq } from "../data/http/requests/user.req";
import { UtilisateurRes } from "../data/http/responses/user.res";
import { AppService } from "../core/app.service";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";


@Injectable({
    providedIn: 'root'
})
export class UtilisateurService extends AbstractService<UtilisateurReq, UtilisateurRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}utilisateur`, http, AppService); 
    }
}